import { ReactComponent as StreakFireIcon } from "assets/icons/streak-fire.svg";
import AvatarInitials from "components/AvatarInitials";
import InfoTooltip from "components/Common/InfoTooltip";
import pluralize from "pluralize";
import LiquidFillGauge from "react-liquid-gauge";
import Skeleton from "react-loading-skeleton";
import { useAppSelector } from "store";
import { getFullName } from "store/user/userActions";

const PostTankGaugeCard = () => {
  // Dummy values for prototyping
  const scheduledPosts = 2;
  const postTankGoal = 10;
  const percent = Math.round((scheduledPosts / postTankGoal) * 100);

  return (
    <div className="rounded-lg bg-antd-colorBgContainer dark:border border-antd-colorBorder p-4 pb-5 w-52 text-antd-colorTextSecondary text-sm flex flex-col gap-4">
      <div className="flex justify-between">
        Post Tank
        <InfoTooltip title="Shows your scheduled posts progress towards your goal" />
      </div>
      <div className="flex-grow flex flex-col items-center justify-center gap-1">
        <div className="relative w-24 h-24 flex items-center justify-center">
          <LiquidFillGauge
            width={96}
            height={96}
            value={percent}
            percent="%"
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            textRenderer={(props) => {
              const value = Math.round(props.value);
              const radius = Math.min(props.height / 2, props.width / 2);
              const textPixels = (props.textSize * radius) / 2;
              const valueStyle = {
                fontSize: textPixels,
              };
              const percentStyle = {
                fontSize: textPixels * 0.6,
              };
              return (
                <tspan>
                  <tspan className="value" style={valueStyle}>
                    {value}
                  </tspan>
                  <tspan style={percentStyle}>{props.percent}</tspan>
                </tspan>
              );
            }}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={[
              {
                key: "0%",
                stopColor: "#006d77",
                stopOpacity: 1,
                offset: "0%",
              },
              {
                key: "50%",
                stopColor: "#008b8b",
                stopOpacity: 1,
                offset: "50%",
              },
              {
                key: "100%",
                stopColor: "#00a896",
                stopOpacity: 1,
                offset: "100%",
              },
            ]}
            circleStyle={{
              fill: "#006d77",
            }}
            waveStyle={{
              fill: "#00a896",
            }}
            textStyle={{
              fill: "#444",
              fontFamily: "Arial",
            }}
            waveTextStyle={{
              fill: "#fff",
              fontFamily: "Arial",
            }}
          />
        </div>
        <div className="text-xs text-center mt-2">
          {scheduledPosts} / {postTankGoal} posts
        </div>
      </div>
    </div>
  );
};

const BusinessHeader = () => {
  const { currentBusiness, userInfo } = useAppSelector((state) => state.user);

  return currentBusiness ? (
    <div className="w-full space-y-8">
      <div className="flex gap-4 items-center">
        <AvatarInitials size={72} business={currentBusiness} />
        <div>
          <div className="font-medium text-xl truncate max-w-[60vw]">
            {currentBusiness.title}
          </div>
          <div className="text-sm text-antd-colorTextTertiary">
            Logged in as {getFullName(userInfo)}
          </div>
        </div>
      </div>
      <div className="flex gap-4">
        <div className="rounded-lg bg-antd-colorBgContainer dark:border border-antd-colorBorder p-4 pb-5 w-52 text-antd-colorTextSecondary text-sm flex flex-col gap-4">
          <div className="flex justify-between">
            Posting Streak
            <InfoTooltip title="Your posting streak is calculated based on your schedule. Always have posts scheduled to keep your streak going!" />
          </div>
          <div className="flex-grow flex items-baseline gap-1">
            <StreakFireIcon className="inline-block h-7" />
            <span className="text-3xl text-antd-colorText font-semibold">
              {currentBusiness.posting_streak}
            </span>{" "}
            {pluralize("post", currentBusiness.posting_streak)}
          </div>
        </div>
        {/* <PostTankGaugeCard /> */}
      </div>
    </div>
  ) : (
    <Skeleton className="h-16" />
  );
};

export default BusinessHeader;
